function LinkToContactUs() {
  return (
    <a href="mailto:contact@kraal.farm" target="_blank" rel="noopener noreferrer" className="font-bold">
      contact@kraal.farm
    </a>
  );
}

export default LinkToContactUs;
